import { Injectable } from '@angular/core';
import { Authentication } from '@/core/models';
import { AuthDomainContext } from './auth.domain';
import { AuthFactoryService } from './auth-factory.service';

@Injectable({ providedIn: 'root' })
export class AuthProcessorService {

  constructor(private readonly authFactory: AuthFactoryService) { }

  /**
   * Calcula los valores de userName, userEmail e isLoggedIn.
   * @param authentication Authentication | null
   * @returns AuthDomainContext
   */
  public processAuthCalculation(authentication: Authentication | null): AuthDomainContext {
    let context: AuthDomainContext = {
      authentication,
      userName: null,
      userEmail: null,
      isLoggedIn: false,
    };

    const rules = this.authFactory.getAuthRules();

    // Recorremos todas las reglas aplicandolas al contexto, pasandole el resultado de la regla anterior como entrada
    let updatedContext = { ...context };
    for (const rule of rules) {
      updatedContext = rule.calculate(updatedContext);
    }

    return updatedContext;
  }
}